import React from 'react';

import { PreviewPanelsContextContainer } from '../controllers';

type PreviewPanelsContainerWrapperProps = {
	children?: React.ReactNode;
};

/**
 * __Preview panel container wrapper__
 *
 * A wrapper component that provides preview panel context to its children.
 * This component should be used at the root level where preview panels functionality is needed.
 *
 * - [Examples](https://atlassian.design/components/preview-panels/examples)
 * - [Code](https://atlassian.design/components/preview-panels)
 */
export const PreviewPanelsContainerWrapper = ({ children }: PreviewPanelsContainerWrapperProps) => {
	return (
		<PreviewPanelsContextContainer scope="preview-panels">{children}</PreviewPanelsContextContainer>
	);
};
